import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/advisors/AdvisorsAction";
import * as uiHelpers from "../AdvisorsUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useAdvisorsUIContext } from "../AdvisorsUIContext";

export function AdvisorsTable({ 
  deleteAdvisors 
}) {
  // Advisors UI Context
  const advisorsUIContext = useAdvisorsUIContext();
  const advisorsUIProps = useMemo(() => {
    return {
      ids: advisorsUIContext.ids,
      setIds: advisorsUIContext.setIds,
      queryParams: advisorsUIContext.queryParams,
      setQueryParams: advisorsUIContext.setQueryParams
    };
  }, [advisorsUIContext]);

  // Getting curret state of Advisors list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.advisors }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;
  
  // Authority Parameters
  const { isDeletionAuthorized } = getAuthorities(authorities);
  
  // Advisors Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getAdvisors(advisorsUIProps.queryParams));
    return () => dispatch(actions.cleanAdvisorsState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advisorsUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "teacher",
      text: "Öğretmen",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "studentName",
      text: "Öğrenci Adı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "studentSurname",
      text: "Öğrenci Soyadı",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "grade",
      text: "Sınıfı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "section",
      text: "Şube",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "sexName",
      text: "Cinsiyeti",
      sort: true,
      sortCaret: sortCaret
    }
  ];

  const actionColumn = {
    dataField: "action",
    text: "İşlemler",
    formatter: columnFormatters.ActionsColumnFormatter,
    formatExtraData: {
      isDeletionAuthorized,
      deleteAdvisors
    },
    classes: "text-center",
    headerClasses: "text-center",
    style: {
      width: "90px",
    }
  }

  if (isDeletionAuthorized) columns.push(actionColumn);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: advisorsUIProps.queryParams.pageSize,
    page: advisorsUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ? entities : [] }
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                advisorsUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: advisorsUIProps.ids,
                setIds: advisorsUIProps.setIds,
                hidden: !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}